import React, { useEffect, useState } from "react";
import { ApiService } from "../../components/Common/ApiService";
import { isIdTarget } from "../../store/actions/todoActions";
import CryptoJS from "crypto-js";

import { useDispatch } from "react-redux";
import Button from "../../components/Common/Button";
import { isPending } from "../../store/actions/todoActions";

import moment from "moment/moment";
import pusherJs from "pusher-js";
import Datepicker from "react-tailwindcss-datepicker";
import { toast } from "react-toastify";
import { ReactComponent as SearchIcon } from "../../assets/icon/ri_search-line.svg";
import ConditionalRender from "../../components/Common/ConditionalRender";
import Input from "../../components/Common/Input";
import { formatRupiah } from "../../components/Common/utils";
import ModalBox from "../../components/Common/ModalBox";

function ClaimVoucher() {
    const isLogin = localStorage.getItem("isLogin");
    const parseLogin = JSON.parse(isLogin);
    const apiKeyPusher = process.env.REACT_APP_PUSHER_KEY;
    const clusterPusher = process.env.REACT_APP_PUSHER_CLUSTER;
    const clusterName = process.env.REACT_APP_PUSHER_NAME;
    const isWebSetting = localStorage.getItem("isWebSetting");
    const parseWebSetting = JSON.parse(isWebSetting);
    const [historyPesananData, sethistoryPesananData] = useState([]);

    const [historyPesananLoading, sethistoryPesananLoading] = useState(true);
    const [confirmModal, setconfirmModal] = useState(false);
    const [reedemVoucher, setreedemVoucher] = useState("");
    const [expired, setExpired] = useState("");
    const [itemsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(0);
    const [value, setValue] = useState({
        startDate: new Date(),
        endDate: new Date().setMonth(11),
    });

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(isIdTarget(undefined));
    }, [dispatch]);

    useEffect(() => {
        const formattedstartDate = moment(new Date(value.startDate)).format(
            "YYYY-MM-DD"
        );
        const formattedendDate = moment(new Date(value.endDate)).format(
            "YYYY-MM-DD"
        );
        if (isLogin) {
            fetchhistoryPesanan(parseLogin?.apiKey, parseLogin?.token, formattedstartDate, formattedendDate);
        }
    }, [value, currentPage]);

    useEffect(() => {
        // Pusher.logToConsole = true;
        const pusher = new pusherJs(apiKeyPusher, {
            cluster: clusterPusher,
        });
        const channel = pusher.subscribe(clusterName);
        const handleNewMessage = (data) => {
            if (data.statusCode === 200) {
                if (data.Code === "actionLatestOrder") {
                    sethistoryPesananData(data.data);
                }
            }
        };
        channel.bind("latest_order", handleNewMessage);
        return () => {
            channel.unbind("latest_order", handleNewMessage);
            pusher.disconnect();
        };
    }, [apiKeyPusher, historyPesananData]);

    const fetchhistoryPesanan = async (api_key, token, startDate, endDate) => {
        sethistoryPesananLoading(true);
        try {
            const response = await ApiService({
                baseurl: "user/logRedeem",
                parameter: "api_key=" +
                    api_key +
                    "&start_date=" +
                    startDate +
                    "&end_date=" +
                    endDate +
                    "&page=" +
                    currentPage +
                    "&limit=" +
                    itemsPerPage,
                method: "GET",
                XGORDON: "LOGREDEEM",
                token: token,
            });
            sethistoryPesananLoading(false);
            if (response?.statusCode === 200) {
                sethistoryPesananData(response.result.data);
            } else {
                sethistoryPesananData([]);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    const confirmReedemVoucher = async () => {
        dispatch(isPending(true));
        try {
            const params = new URLSearchParams();
            params.append('api_key', parseLogin?.apiKey);
            params.append('giftcard', reedemVoucher);

            const response = await ApiService({
                baseurl: "user/konfirmGiftCard",
                method: "POST",
                XGORDON: "KONFIRMGIFTCARD",
                body: params,
                apiKey: parseLogin?.apiKey,
                token: parseLogin?.token,

            });
            dispatch(isPending(false));
            if (response?.statusCode === 200) {
                setconfirmModal(true)
                setExpired(response?.result.data.expired)
                console.log(response?.result.data.expired);
            } else {
                toast.error(response?.result.msg, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    const changeReedemVoucher = async () => {
        dispatch(isPending(true));
        const parsedObject = JSON.parse(isLogin);
        const originalString = `${reedemVoucher}${expired}${parsedObject?.apiKey}`;
        console.log(originalString);
        const sha256Hash = CryptoJS.SHA256(originalString).toString();
        try {
            const params = new URLSearchParams();
            params.append('api_key', parseLogin?.apiKey);
            params.append('voucher_code', reedemVoucher);

            const response = await ApiService({
                baseurl: "user/redeem",
                method: "POST",
                customHeaders: { "x-gorgon": sha256Hash },
                XGORDON: "REDEEM",
                body: params,
                apiKey: parseLogin?.apiKey,
                token: parseLogin?.token,

            });
            dispatch(isPending(false));
            if (response?.statusCode === 200) {
                toast.success(response?.result.msg, {
                    position: toast.POSITION.TOP_RIGHT,
                });
                setconfirmModal(false)
            } else {
                toast.error(response?.result.msg, {
                    position: toast.POSITION.TOP_RIGHT,
                });
                setconfirmModal(true)
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    const handleNextPage = () => {
        setCurrentPage((halamanSebelumnya) => halamanSebelumnya + itemsPerPage);
    };

    const handlePreviousPage = () => {
        if (currentPage > 0) {
            setCurrentPage((halamanSebelumnya) => halamanSebelumnya - itemsPerPage);
        }
    };
    return (
        <div className="flex flex-col gap-3 flex-1 relative ">
            <div className="flex flex-row lg:rounded-lg rounded-none shadow-inner  bg-cardLight dark:bg-cardDark sm: min-h-[100px] relative">
                <div className="flex flex-col gap-2 justify-center flex-1 p-3">
                    <span className="text-[#22BDE2] text-2xl font-bold"> Klaim Voucher
                    </span>
                    <span className=" text-base font-light ">
                        Jika kamu telah memesan namun pesanan tidak terdaftar, tunggu 3-5 menit. Namun jika tak kunjung muncul silahkan cek lewat form dibawah
                    </span>

                    <span className=" text-base font-semibold"> Redeem Giftcard</span>
                    <div className="flex flex-row items-center gap-2">
                        <div className="flex flex-1">
                            <Input
                                id={1}
                                value={reedemVoucher}
                                onChange={(value) => {
                                    const inputValue = value;
                                    setreedemVoucher(inputValue);
                                }}
                                type={"text"}
                                bgcolor={"bg-[#edeeee]"}
                                placeholder={`Masukan kode Giftcard`}
                            />
                        </div>
                        <Button
                            iconLeft={<SearchIcon className="h-5 w-5" />}
                            type="fill"
                            color={'#ffffff'}
                            className={"bg-gradient-to-r from-[#22BDE2] to-[#FC00FF] text-darkColor"}
                            onClick={() => {
                                if (reedemVoucher.length < 4) {
                                    toast.error("Kode GiftCard Kosong", {
                                        position: toast.POSITION.TOP_RIGHT,
                                    });
                                } else {
                                    confirmReedemVoucher();
                                }
                            }}
                        />
                    </div>
                </div>
                <div className="md:flex hidden flex-1">
                    <img
                        src={require('../../assets/images/pngwing 1.png')}
                        alt="Logo"
                        className="object-cover  object-right flex-1 h-full rounded-md" />
                </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-2 sm:justify-between items-center lg:rounded-lg rounded-none shadow-inner overflow-hidden bg-cardLight dark:bg-cardDark p-3 relative">
                <div className="flex flex-col flex-1">
                    <span className="font-bold text-lg  line-clamp-1 ">Live Transaksi
                    </span>
                    <span className=" text-base italic  ">
                        Menampilkan 10 Transaksi dari semua jenis pembelian produk
                    </span>
                </div>

                <div className="flex sm:w-48 w-full">
                    <div className="outline rounded-md outline-[#22BDE2]  ">
                        <Datepicker
                            value={value}
                            onChange={(a) => {
                                setValue(a);
                            }}
                            showShortcuts={true}
                            classNames={"bg-red-400 "}
                            primaryColor={"blue"}
                            inputClassName={'text-[#22BDE2] px-3 bg-transparent w-full h-10'}

                        />
                    </div>
                </div>
            </div>
            <div className="flex flex-col lg:rounded-lg rounded-none  shadow-inner bg-cardLight dark:bg-cardDark overflow-hidden relative">

                <div className=" pb-3 min-h-[620px]  relative">
                    <div className="overflow-x-scroll no-scrollbar  absolute top-0 left-0 right-0 bottom-0 lg:rounded-lg rounded-none">
                        <ConditionalRender
                            productsData={historyPesananData}
                            isLoading={historyPesananLoading}
                            model={"emptyData"}
                        >
                            <table className="min-w-full text-left text-sm font-light table-auto ">
                                <thead className="border-b  font-medium bg-gradient-to-r from-[#22BDE2] to-[#FC00FF] text-darkColor">
                                    <tr>
                                        <th scope="col" className=" p-3">#</th>
                                        <th scope="col" className=" p-3">KODE VOUCER</th>
                                        <th scope="col" className=" p-3">NOMINAL</th>
                                        <th scope="col" className=" p-3">TANGGAL</th>
                                        <th scope="col" className=" p-3">STATUS</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {historyPesananData.map((item, index) => (
                                        <tr key={index}
                                            className={`border-b border-[#ffffff2d] ${index % 2 === 0 ? 'bg-[#DFF9FF] dark:bg-[#ffffff13]' : ''
                                                }`}>
                                            <td className="whitespace-nowrap  p-3 font-medium text-center">{index + 1}</td>
                                            <td className="whitespace-nowrap  p-3"> {item.voucher_code}</td>
                                            <td className="whitespace-nowrap  p-3"> {formatRupiah(item.nominal)}</td>
                                            <td className="whitespace-nowrap  p-3">{item.date}</td>
                                            <td className="whitespace-nowrap flex-col p-2">
                                                <div className="flex flex-row">
                                                    <div className={`${item.status === "cancel"
                                                        ? "bg-[#F42536]"
                                                        : item.status === "refund"
                                                            ? "bg-[#ED610A]"
                                                            : item.status === "pending"
                                                                ? "bg-[#ED610A]"
                                                                : item.status === "paid"
                                                                    ? "bg-[#ED610A]"
                                                                    : item.status === "not_paid"
                                                                        ? "bg-[#000000]"
                                                                        : item.status === "processing"
                                                                            ? "bg-[#3694ff]"
                                                                            : item.status === "success"
                                                                                ? "bg-[#0ABE5D]"
                                                                                : null
                                                        } rounded-tr-lg rounded-bl-lg `}>
                                                        <span className=" text-xs font-medium line-clamp-1 m-2 my-1">
                                                            {item.status}
                                                        </span>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </ConditionalRender>
                    </div>
                    <div className="absolute bottom-3 gap-2 flex right-3 z-20 left-3  items-center justify-center">
                        <Button
                            disabled={currentPage <= 0}
                            initialValue="Sebelumnya"
                            type="fill"
                            className={`border-[#22BDE2] border-2 text-[#22BDE2] dark:border-[#ffffff] h-[40px] dark:text-darkColor  sm:inline-flex rounded-md ${currentPage <= 0 ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                            onClick={() => { handlePreviousPage() }}
                        />
                        <Button
                            disabled={historyPesananData.length === 0}
                            initialValue="Selanjutnya"
                            type="fill"
                            className={`border-[#22BDE2] border-2 text-[#22BDE2] dark:border-[#ffffff] h-[40px] dark:text-darkColor  sm:inline-flex rounded-md ${historyPesananData.length <= 0 ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                            onClick={() => handleNextPage()}
                        />
                    </div>
                </div>
            </div>


            <ModalBox active={confirmModal} onClose={() => {
                setconfirmModal(false)
            }}>
                <div className="flex flex-col gap-3">
                    <div className="flex flex-row justify-center">
                        <span className=" text-center text-darkColor">Apakah Anda Ingin Redeem Gift Card ?</span>
                    </div>
                    <div className="flex flex-row flex-1 gap-3">
                        <Button
                            initialValue="Tidak"
                            type="fill"
                            color={"#ffffff"}
                            className=" bg-lightColor text-lightColor flex-1"
                            onClick={() => {
                                setconfirmModal(false)
                            }}
                        />
                        <Button
                            initialValue="Iya"
                            type="fill"
                            color={"#ffffff"}
                            className=" bg-[#132239] text-darkColor flex-1"
                            onClick={() => {
                                changeReedemVoucher()
                            }}
                        />
                    </div>
                </div>
            </ModalBox>
        </div>
    );
}

export default ClaimVoucher;
